import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../Layout/Layout';

function CookiePolicy() {
    return (
        <Layout>
        <div className="policy-page-wrapper bg-blue-50">
            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col-12">
                        <h1 className="mb-4">Cookie Policy</h1>
                        <p className="text-muted mb-4"><strong>Last Updated:</strong> April 2, 2026</p>

                        {/* Introduction */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">1. What Are Cookies?</h2>
                            <p>
                                Cookies are small text files that are placed on your computer, tablet, smartphone, or other device
                                when you visit a website. They are widely used to make websites work more efficiently and to provide
                                information to the website owners. Cookies can be stored on your device for various periods of time,
                                from a single session to several years.
                            </p>
                        </section>

                        {/* Types of Cookies */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">2. Types of Cookies We Use</h2>

                            <h5 className="mt-4 mb-2">2.1 Essential Cookies (Strictly Necessary)</h5>
                            <p>
                                These cookies are necessary for the website to function properly. They enable core functionality such as
                                security, network management, and accessibility. Without essential cookies, you may not be able to use
                                certain features of our Services.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Cookie Name</th>
                                            <th>Purpose</th>
                                            <th>Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>session_id</td>
                                            <td>Maintains your login session</td>
                                            <td>Session</td>
                                        </tr>
                                        <tr>
                                            <td>csrf_token</td>
                                            <td>Prevents Cross-Site Request Forgery attacks</td>
                                            <td>Session</td>
                                        </tr>
                                        <tr>
                                            <td>user_preferences</td>
                                            <td>Stores your account preferences</td>
                                            <td>1 year</td>
                                        </tr>
                                        <tr>
                                            <td>auth_token</td>
                                            <td>Authenticates your identity</td>
                                            <td>30 days</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5 className="mt-4 mb-2">2.2 Performance Cookies (Analytics)</h5>
                            <p>
                                These cookies help us understand how visitors interact with our website. They collect information about
                                the number of visitors, how visitors use our website, and where visitors come from. This information is
                                aggregated and does not identify individual users.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Cookie Name</th>
                                            <th>Provider</th>
                                            <th>Purpose</th>
                                            <th>Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>_ga, _gid, _gat</td>
                                            <td>Google Analytics</td>
                                            <td>Website analytics and traffic tracking</td>
                                            <td>2 years</td>
                                        </tr>
                                        <tr>
                                            <td>_utm*</td>
                                            <td>Google Analytics</td>
                                            <td>Campaign tracking</td>
                                            <td>Session</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5 className="mt-4 mb-2">2.3 Functional Cookies</h5>
                            <p>
                                These cookies enable personalized features and enhanced functionality. They remember your choices
                                and preferences to provide a more customized experience.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Cookie Name</th>
                                            <th>Purpose</th>
                                            <th>Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>language_preference</td>
                                            <td>Remembers your language preference</td>
                                            <td>1 year</td>
                                        </tr>
                                        <tr>
                                            <td>theme_preference</td>
                                            <td>Remembers your UI theme choice (light/dark)</td>
                                            <td>1 year</td>
                                        </tr>
                                        <tr>
                                            <td>notification_settings</td>
                                            <td>Stores your notification preferences</td>
                                            <td>1 year</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h5 className="mt-4 mb-2">2.4 Marketing Cookies (Third-Party)</h5>
                            <p>
                                These cookies are used to track your activity across websites and build a profile of your interests
                                for targeted advertising. These are used with your consent only.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>Cookie Name</th>
                                            <th>Provider</th>
                                            <th>Purpose</th>
                                            <th>Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>_fbp</td>
                                            <td>Facebook</td>
                                            <td>Targeted advertising and user tracking</td>
                                            <td>3 months</td>
                                        </tr>
                                        <tr>
                                            <td>IDE, ANID</td>
                                            <td>Google Ads</td>
                                            <td>Interest-based advertising</td>
                                            <td>2 years</td>
                                        </tr>
                                        <tr>
                                            <td>tt_appInfo</td>
                                            <td>TikTok</td>
                                            <td>Tracking for marketing purposes</td>
                                            <td>1 year</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>

                        {/* GDPR Compliance */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">3. GDPR Compliance (EU Residents)</h2>

                            <h5 className="mt-4 mb-2">3.1 Cookie Consent</h5>
                            <p>
                                Under GDPR, we must obtain your explicit consent before storing or accessing any non-essential cookies
                                on your device. Essential cookies that are strictly necessary for the service to function do not require
                                consent. When you visit our website, you will be presented with a cookie consent banner that allows you to:
                            </p>
                            <ul>
                                <li>Accept all cookies</li>
                                <li>Reject non-essential cookies</li>
                                <li>Customize your cookie preferences</li>
                            </ul>

                            <h5 className="mt-4 mb-2">3.2 Your GDPR Rights Regarding Cookies</h5>
                            <p>You have the right to:</p>
                            <ul>
                                <li><strong>Withdraw Consent:</strong> Withdraw your consent at any time through your cookie settings</li>
                                <li><strong>Access Information:</strong> Request information about cookies we use</li>
                                <li><strong>Object to Processing:</strong> Object to cookie-based profiling and tracking</li>
                                <li><strong>Data Portability:</strong> Request data collected through cookies</li>
                            </ul>

                            <h5 className="mt-4 mb-2">3.3 Cookie Banner and Preferences</h5>
                            <p>
                                You can manage your cookie preferences at any time by:
                            </p>
                            <ol>
                                <li>Clicking the "Cookie Preferences" link in our footer</li>
                                <li>Using the cookie consent banner that appears on first visit</li>
                                <li>Accessing your account settings and privacy preferences</li>
                            </ol>
                        </section>

                        {/* CCPA/CPRA Compliance */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">4. CCPA/CPRA Compliance (California Residents)</h2>

                            <h5 className="mt-4 mb-2">4.1 Cookie-Based Tracking and CCPA</h5>
                            <p>
                                Under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA), cookies may
                                constitute "personal information" or facilitate the collection and sale of personal information. We
                                comply with CCPA/CPRA requirements by:
                            </p>
                            <ul>
                                <li>Providing clear information about the cookies we use</li>
                                <li>Allowing you to opt-out of the sale or sharing of personal information collected through cookies</li>
                                <li>Not using cookies in a manner that violates your privacy rights</li>
                                <li>Responding to your requests to delete information collected through cookies</li>
                            </ul>

                            <h5 className="mt-4 mb-2">4.2 Opt-Out of Cookies (California Residents)</h5>
                            <p>
                                California residents have the right to opt-out of the sale or sharing of personal information. You can:
                            </p>
                            <ol>
                                <li>Click the "Do Not Share My Personal Information" link in our footer</li>
                                <li>Manage your cookie preferences through our cookie banner</li>
                                <li>Use the browser-based Global Opt-Out Preference Signal if available</li>
                                <li>Contact us at neuratrader@gmail.com to exercise your rights</li>
                            </ol>

                            <h5 className="mt-4 mb-2">4.3 Non-Discrimination</h5>
                            <p>
                                We will not discriminate against you for exercising your CCPA/CPRA rights regarding cookies.
                                We will not deny, charge different prices, or provide different service based on your privacy choices.
                            </p>
                        </section>

                        {/* How to Control Cookies */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">5. How to Control Cookies</h2>

                            <h5 className="mt-4 mb-2">5.1 Browser Settings</h5>
                            <p>
                                Most browsers allow you to control cookies through their settings. You can:
                            </p>
                            <ul>
                                <li>View cookies stored on your device</li>
                                <li>Delete cookies individually or all cookies</li>
                                <li>Block cookies from specific websites</li>
                                <li>Block third-party cookies</li>
                                <li>Block cookies except for trusted sites</li>
                            </ul>
                            <p className="mt-3"><strong>Browser Instructions:</strong></p>
                            <ul>
                                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-primary">Chrome</a></li>
                                <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-primary">Firefox</a></li>
                                <li><a href="https://support.apple.com/en-us/HT201265" target="_blank" rel="noopener noreferrer" className="text-primary">Safari</a></li>
                                <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406c7f5" target="_blank" rel="noopener noreferrer" className="text-primary">Edge</a></li>
                            </ul>

                            <h5 className="mt-4 mb-2">5.2 Website Cookie Preferences</h5>
                            <p>
                                When you first visit our website, a cookie consent banner will appear. You can:
                            </p>
                            <ul>
                                <li>Accept all cookies</li>
                                <li>Reject non-essential cookies</li>
                                <li>Customize your preferences for each cookie category</li>
                            </ul>

                            <h5 className="mt-4 mb-2">5.3 Opt-Out of Analytics</h5>
                            <p>
                                You can opt-out of Google Analytics tracking by installing the{' '}
                                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-primary">
                                    Google Analytics Opt-out Browser Add-on
                                </a>.
                            </p>

                            <h5 className="mt-4 mb-2">5.4 Note on Disabling Cookies</h5>
                            <p>
                                <strong>Important:</strong> Disabling cookies may affect the functionality of our Services.
                                Essential cookies cannot be disabled, but you can control non-essential cookies. If you disable
                                cookies, you may not be able to use certain features such as automatic login or personalized content.
                            </p>
                        </section>

                        {/* Third-Party Cookies */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">6. Third-Party Cookies</h2>
                            <p>
                                Our website may contain links to third-party websites and may embed content from third parties such as
                                YouTube, Google Maps, and social media platforms. These third parties may use their own cookies for tracking
                                and analytics purposes.
                            </p>
                            <p>
                                We are not responsible for third-party cookies. We recommend reviewing the privacy policies and cookie
                                policies of these third parties:
                            </p>
                            <ul>
                                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary">Google Privacy Policy</a></li>
                                <li><a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer" className="text-primary">Facebook Privacy Policy</a></li>
                                <li><a href="https://www.youtube.com/intl/en/howyoutubeworks/user-settings/privacy/" target="_blank" rel="noopener noreferrer" className="text-primary">YouTube Privacy</a></li>
                            </ul>
                        </section>

                        {/* Do Not Track */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">7. Do Not Track Signals</h2>
                            <p>
                                Some browsers include a "Do Not Track" (DNT) feature. Our Services do not currently respond to DNT signals
                                from browsers. However, you can still control cookies through browser settings or our cookie preferences.
                            </p>
                        </section>

                        {/* Cookie Updates */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">8. Updates to Cookies</h2>
                            <p>
                                We may update the cookies we use from time to time. Changes may be due to:
                            </p>
                            <ul>
                                <li>Service improvements and new features</li>
                                <li>Compliance with new regulations</li>
                                <li>Enhanced security measures</li>
                                <li>Changes to third-party service providers</li>
                            </ul>
                            <p>
                                We will update this Cookie Policy to reflect these changes. We encourage you to review this policy
                                periodically to stay informed about how we use cookies.
                            </p>
                        </section>

                        {/* Contact Information */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">9. Questions About Cookies?</h2>
                            <p>
                                If you have questions about our use of cookies, please refer to our{' '}
                                <Link to="/privacy-policy" className="text-primary">Privacy Policy</Link>,{' '}
                                <Link to="/terms-and-conditions" className="text-primary">Terms and Conditions</Link>, or contact us:
                            </p>
                            <ul>
                                <li><strong>Email:</strong> neuratrader@gmail.com</li>
                                {/* <li><strong>Support:</strong> <a href="https://t.me/CyanCastle" className="text-primary">Telegram</a></li>
                                <li><strong>Mail:</strong> Auto Crypto Bot, Privacy Department, [Physical Address]</li> */}
                            </ul>
                        </section>

                        {/* Cookie Consent Summary */}
                        <section className="mb-5">
                            <h2 className="h4 mb-3">10. Cookie Consent Summary Table</h2>
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Cookie Type</th>
                                            <th>Consent Required</th>
                                            <th>Can Be Disabled</th>
                                            <th>Purpose</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Essential/Strictly Necessary</td>
                                            <td>No</td>
                                            <td>No</td>
                                            <td>Core functionality and security</td>
                                        </tr>
                                        <tr>
                                            <td>Performance/Analytics</td>
                                            <td>Yes (GDPR)</td>
                                            <td>Yes</td>
                                            <td>Website usage and improvement</td>
                                        </tr>
                                        <tr>
                                            <td>Functional</td>
                                            <td>Yes (GDPR)</td>
                                            <td>Yes</td>
                                            <td>Enhanced personalization</td>
                                        </tr>
                                        <tr>
                                            <td>Marketing/Advertising</td>
                                            <td>Yes</td>
                                            <td>Yes</td>
                                            <td>Targeted advertising and tracking</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        </Layout>
    );
}

export default CookiePolicy;